import { Box, Button, Typography } from "@mui/material";
import SuccessIcon from "assets/icons/Success";
import { EPath } from "constants/path";
import { SessionStorageKeys } from "constants/secureStorage";
import { useNavigate } from "react-router";
import { buttonVariants } from "utils/muiTailwindStyles";

interface SignUpSuccessfullyProps {
  email?: string;
}

function SignUpSuccessfully({ email }: SignUpSuccessfullyProps) {
  const navigate = useNavigate();
  return (
    <Box className="p-16 max-w-[552px] border bg-white rounded-xl space-y-6 border-color_E8E8E9 border-1">
      <Box className="text-center space-y-6">
        <Typography
          variant="h5"
          component="h5"
          className="text-2xl leading-7 text-surface-dark"
        >
          Sign Up Successfully
        </Typography>

        <Box>
          <Typography variant="body2" className="text-black text-base">
            Your account has been created successfully.
          </Typography>
          <Typography variant="body2" className="text-black text-base">
            You can now log in using your registered <br /> email and password.
          </Typography>
        </Box>

        <SuccessIcon />

        <Button
          variant="contained"
          className={`${buttonVariants.primary.className} w-full text-base rounded-full py-3 disabled:text-surface-light disabled:opacity-40`}
          sx={{
            ...buttonVariants.primary.sx,
          }}
          onClick={() => {
            // Store the email in sessionStorage for pre-filling the login form
            if (email) {
              sessionStorage.setItem(SessionStorageKeys.SIGN_UP_EMAIL, email);
            }
            navigate(EPath.LOGIN);
          }}
        >
          Back to Log In
        </Button>
      </Box>
    </Box>
  );
}

export default SignUpSuccessfully;
